import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { extract } from '../../util/util';
import ReactSelect from '../../components/ReactSelect';
import SaveButton from '../../components/SaveButton';
import { toast } from 'react-toastify';


export default function CadastroProdutoBu({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/produtoBu/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'unidadenegocio',
                    ]
                });
                console.log(dadosRecebidos);
                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            setIsLoading(false);
        }
    };

    const salvar = () => {
        
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
if (id) {//update
            api({
                method: 'put',
                action: '/produtoBu/' + id,
                token: token,
                data: dados
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/produtoBu");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            api({
                method: 'post',
                action: '/produtoBu',
                token: token,
                data: { ...dados, ...{ empresa: empresa } }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/produtoBu");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>Bu</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Unidade de Negócio</label>
                                                        <ReactSelect
                                                            value={{ value: dados.unidadenegocio, label: dados.nomeUnidadenegocio }}
                                                            onChange={e => setDados({ ...dados, ...{ "unidadenegocio": e.value, "nomeUnidadenegocio": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/produtoUnidadeNegocio',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Nome"
                                                            value={dados.nome}
                                                            onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <SaveButton isSubmitting={isSubmitting} />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}